module.exports = __webpack_public_path__ + "img/blue_sky_bio.b67a2664.png";